import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import bookdetails from '../Assets/restop down.jpg'

function Service4() {
  return (
    <>
    <Navbar/>
    <div className='aboutbanner aboutbanner8'>
    <h3>The Restore Suite</h3>
    {/* <p>Escape, Recharge & Renew</p> */}

    </div>
    <div className='about-classes'>
    <div className='about-classes-left'>
    {/* <h3>Unwind your body, quiet your mind, and find deep inner calm.</h3> */}
    <p>A private sanctuary designed for deep relaxation and rejuvenation — perfect for individuals or pairs seeking peace and restoration.

</p>

    {/* <p>Through gentle stretching, long-held postures, and mindful breathing, you’ll create space in your body and mind, allowing you to feel lighter, calmer, and deeply restored.</p> */}

    
    <ul>
    <li><b>Steam Room </b> Detoxify your body and ease muscle tension in a calming steam environment.</li>
    <li><b>Ice Baths </b> A refreshing plunge that promotes circulation, reduces inflammation, and boosts energy.</li>
    <li><b>Relaxation Area </b> A tranquil space to unwind, reflect, and restore your inner calm.</li>


       

    </ul>

    

    
</div>
   <div className='about-classes-right'>
<img src={bookdetails}/>
 

</div>
    </div>
    <Footer/>
   </>
  )
}

export default Service4